import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { interval } from 'patronum'
import { FeatureFlag } from '~/shared/api'
import { FeatureFlags, FeatureFlagsEnum } from './constants'

type FeatureFlagsState = {
  [K in FeatureFlagsEnum]: boolean
}

function getFeatureFlagsState(keys: FeatureFlagsEnum[]): FeatureFlagsState {
  const allFlags = Object.values(FeatureFlags) as FeatureFlagsEnum[]

  return Object.fromEntries(
    allFlags.map((flag) => [flag, keys.includes(flag)]),
  ) as FeatureFlagsState
}

const domain = createDomain('shared.lib.featureFlag')
export const Gate = createGate()

const getFeatureFlags = domain.createEvent()

export const getFeatureFlagsFx = domain.createEffect<void, FeatureFlagsEnum[]>({
  async handler() {
    const res = await FeatureFlag.getFlags()
    return res
  },
})

const getFeatureFlagsSilentFx = domain.createEffect<void, FeatureFlagsEnum[]>({
  async handler() {
    const res = await FeatureFlag.getFlags()
    return res
  },
})

sample({
  clock: Gate.open,
  target: getFeatureFlags,
})

sample({
  clock: getFeatureFlags,
  target: getFeatureFlagsFx,
})

export const $featureFlags = domain
  .createStore<FeatureFlagsState>(getFeatureFlagsState([]))
  .on(
    [getFeatureFlagsFx.doneData, getFeatureFlagsSilentFx.doneData],
    (_, featureFlags) => getFeatureFlagsState(featureFlags || []),
  )

const intervalRequestStarted = domain.createEvent()
const intervalRequestStopped = domain.createEvent()

const { tick } = interval({
  timeout: 60000,
  start: intervalRequestStarted,
  stop: intervalRequestStopped,
  leading: false,
  trailing: false,
})

sample({
  clock: tick,
  target: getFeatureFlagsSilentFx,
})

sample({
  clock: Gate.open,
  target: intervalRequestStarted,
})
sample({
  clock: Gate.close,
  target: intervalRequestStopped,
})
